import React, { useCallback, useMemo } from 'react';
import { get } from 'lodash';
import withCurrentlyPlayingCallId from '../../../hoc/withCurrentlyPlayingCallId';
import withUpdateAlert from '../../../hoc/withUpdateAlert';
import AudioActivityItem from './AudioActivityItem';

function AudioActivityItemContainer(props) {
  const {
    activity = {},
    mutateUpdateAlert,
    setCurrentlyPlayingCallId,
    currentlyPlayingCallId,
    ...rest
  } = props;

  const onPlayAudio = useCallback(() => {
    const call = activity.call || {};
    if (call.alert && !call.alert.completed_at) {
      mutateUpdateAlert({ completed: true, id: call.alert.id });
    }
    setCurrentlyPlayingCallId(call.id);
  }, [activity, mutateUpdateAlert, setCurrentlyPlayingCallId]);

  const isPlaying = useMemo(() => {
    const callId = get(activity, 'call.id');
    return callId === currentlyPlayingCallId;
  }, [activity, currentlyPlayingCallId]);

  return (
    <AudioActivityItem
      {...rest}
      activity={activity}
      onPlayAudio={onPlayAudio}
      isPlaying={isPlaying}
    />
  );
}

export default withUpdateAlert(withCurrentlyPlayingCallId(AudioActivityItemContainer));
